// Module
var code = "<div class=\"cart-line__autoship\"> <div class=\"cart-line__autoship-selector\" data-region=\"options\"> <div data-placeholder=\"options\"></div> </div> <div class=\"cart-line__autoship-selector\" data-region=\"frequency\"> <div data-placeholder=\"frequency\"></div> </div> </div> ";
// Exports
module.exports = code;